import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc94089"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "track-wrap" }
const _hoisted_2 = { class: "table-box pc-wrap" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "flex-c-center pt20 pb20"
}
const _hoisted_6 = {
  class: "phone-wrap",
  style: {"height":"calc(100% - 0.98rem)"}
}
const _hoisted_7 = { style: {"text-align":"right","padding-top":"0.2rem"} }
const _hoisted_8 = { class: "track phone-wrap" }
const _hoisted_9 = { class: "pagination" }

import {defineAsyncComponent, ref, watch} from 'vue'
import { fileTrackApi } from '@/api/file'
import {useRoute} from "vue-router";
import { useAddress } from '@/utils/getAddress';
import Tips from '@/components/Tips/Tips.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Track',
  props: {
  data: {
    type: Object,
    default: () => {}
  }
},
  setup(__props) {

const TrackItem = defineAsyncComponent(() => import("@/views/member/file/components/phone/TrackItem.vue"));

const props = __props

const route = useRoute();

/**
 * 文件列表处理
 */
const tableData = ref<any>([])
const tableParams = ref({ id: '', limit: 10, page: 1, title: '' })
const tableTotal = ref(0)
// 获取文件列表
const getFileList = async () => {
  const res: any = await fileTrackApi(tableParams.value)
  // console.log(res)
  tableData.value = res.data
  tableTotal.value = res.total
}

watch(
  () => props.data,
  () => {
    if (props.data && props.data.id) {
      tableParams.value.id = props.data.id
    }else{
      tableParams.value.id = '' + route.query.id
    }
    if (tableParams.value.id){
      getFileList()
    }
  },
  { deep: true, immediate: true }
)

console.log(route.query.id, 'route');

const addressInfo = useAddress();
const {showAddress} = addressInfo;

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_table, {
        ref: "multipleTableRef",
        data: tableData.value,
        style: {"width":"100%"},
        height: "440px",
        size: "default",
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "createtime",
            label: "时间",
            width: "180",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "nickname",
            label: "用户",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "num",
            label: "第几次浏览",
            width: "80",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "address",
            label: "地区",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(({row}) => [
              (+row.address_button === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.address), 1))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (!row.addressStr)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          link: "",
                          onClick: ($event: any) => (_unref(showAddress)(row, 2, getFileList))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("点击查看")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.addressStr), 1))
                  ], 64))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "ip",
            label: "IP",
            width: "150",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "shebei",
            label: "访问设备",
            width: "80",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "pingtai",
            label: "访问平台",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "file_name",
            label: "访问文档",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "timenum",
            label: "停留时长",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "plan",
            label: "浏览进度",
            width: "80",
            align: "center",
            "show-overflow-tooltip": ""
          })
        ]),
        _: 1
      }, 8, ["data"]),
      (tableTotal.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_el_pagination, {
              background: "",
              layout: "total, prev, pager, next, jumper",
              "current-page": tableParams.value.page,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((tableParams.value.page) = $event)),
              "page-size": tableParams.value.limit,
              "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((tableParams.value.limit) = $event)),
              total: tableTotal.value,
              onCurrentChange: getFileList
            }, null, 8, ["current-page", "page-size", "total"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(Tips)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (tableData.value.length)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(tableData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(TrackItem), {
                key: index,
                data: item,
                onShowAddress: ($event: any) => (_unref(showAddress)(item, 2, getFileList))
              }, null, 8, ["data", "onShowAddress"]))
            }), 128))
          : (_openBlock(), _createBlock(_component_el_empty, { key: 1 }))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_el_pagination, {
          background: "",
          layout: "prev, next",
          "current-page": tableParams.value.page,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((tableParams.value.page) = $event)),
          "page-size": tableParams.value.limit,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((tableParams.value.limit) = $event)),
          total: tableTotal.value,
          onCurrentChange: getFileList
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ])
  ]))
}
}

})